module.exports = __webpack_public_path__ + "img/checkmark.9ee9f091.svg";